import { buildParams } from '@/helpers/url';

const initialState = {
  essPermission: {},
  isLoadingEss: false,
  currencies: [],
  goalsData: {
    type: [
      { id: 1, name: 'Individual' },
      { id: 2, name: 'Team' },
      { id: 3, name: 'Organization' },
      { id: 4, name: 'Company' },
    ],
    status: [
      { id: 1, name: 'On going' },
      { id: 2, name: 'Closed' },
      { id: 3, name: 'Requested' },
    ],
    progress: [
      { id: 1, name: 'On Track' },
      { id: 2, name: 'Off Track' },
    ],
    measurementType: [
      { id: 2, name: 'Percentage (%)' },
      { id: 3, name: 'Number' },
      { id: 4, name: 'Currency' },
      { id: 5, name: 'Deadline' },
    ],
    cycle: [
      {
        value: 1,
        label: 'Custom',
        uuid: 'c7c8e5cb-7423-4d40-a562-26a6787e2389',
        id_old: 5,
      },
      {
        value: 2,
        label: 'Monthly',
        uuid: '79d921aa-9cfc-4877-b227-3e281cbc86d7',
        id_old: 1,
      },
      {
        value: 3,
        label: 'Quarterly',
        uuid: '2633e1f8-1c48-4f06-a54e-47d87b910e63',
        id_old: 2,
      },
      {
        value: 4,
        label: 'Half-yearly',
        uuid: 'bee0e8d1-db79-46a8-9480-05f03b8bf9ff',
        id_old: 3,
      },
      {
        value: 5,
        label: 'Yearly',
        uuid: '0359f027-8a7c-475f-a9b5-098d7e73d0b1',
        id_old: 4,
      },
    ],
    request_status: [
      { id: 1, name: 'All request type', value: 'all-goal' },
      { id: 2, name: 'Create new goal', value: 'create-goal' },
      { id: 3, name: 'Edit goal', value: 'edit-goal' },
      { id: 4, name: 'Update goal', value: 'update-goal' },
    ],
  },
  isRequestedGoal: null,
  isModalGoalType: false,
  selectedGoalType: 1,
  goalTypes: [
    {
      value: 1,
      name: 'Individual',
      icon: 'employee',
      title: 'align employee performance with company objectives or personal development targets.',
    },
    {
      value: 2,
      name: 'Team',
      icon: 'team',
      title: 'align group of employee performance with organization target and/or with company objectives.',
    },
    {
      value: 3,
      name: 'Organization',
      icon: 'organizations-h',
      title: 'align division performance with other division targets and/or with company objectives.',
    },
    {
      value: 4,
      name: 'Company',
      icon: 'company',
      title: 'can align with other derived goals or key results within the organization and employees.',
    },
  ],
  goalSettings: {},
  bulkActionEmployeeIds: [],
  bulkActionGoalUuids: [],
};

const mutations = {
  SET_ESS_PERMISSIONS(state, payload) {
    localStorage.essPermission = JSON.stringify(payload);
    state.essPermission = payload;
  },
  SET_IS_LOADING_ESS(state, payload) {
    state.isLoadingEss = payload;
  },
  SET_IS_REQUESTED_GOAL(state, payload) {
    state.isRequestedGoal = payload;
  },
  SET_CURRENCIES(state, currencies) {
    state.currencies = currencies;
  },
  setGoalSettings(state, payload) {
    state.goalSettings = payload;
  },
  SET_BULK_ACTION_EMPLOYEE_IDS(state, payload) {
    state.bulkActionEmployeeIds = payload;
  },
  SET_BULK_ACTION_GOAL_UUIDS(state, payload) {
    state.bulkActionGoalUuids = payload;
  },
};

const getters = {
  goalsData(state) {
    return state.goalsData;
  },
  isValidEssPermission(state) {
    state.essPermission = JSON.parse(localStorage.essPermission);
    return state.essPermission?.userHavePermission;
  },
  approvalSettingsLink(state) {
    state.essPermission = JSON.parse(localStorage.essPermission);
    return state.essPermission?.redirectUrl || '';
  },
  selectedType(state) {
    return state.goalTypes.find(e => e.value === state.selectedGoalType);
  },
  currencies(state) {
    return state.currencies;
  },
  isEligibleCreateGoal(state) {
    return !!state.goalSettings?.is_eligible_create_goal;
  },
  bulkActionEmployeeIds(state) {
    return state.bulkActionEmployeeIds;
  },
  bulkActionGoalUuids(state) {
    return state.bulkActionGoalUuids;
  },
};

const actions = {
  async fetchCurrencies({ commit }) {
    try {
      const { data } = await this._vm.$axios.get(`${this._vm.$newEndPoint}/goals/currencies`);
      commit('SET_CURRENCIES', data?.contents || []);
    } catch (e) {
      console.error(e);
    }
  },
  setBulkActionEmployeeIds({ commit }, payload) {
    commit('SET_BULK_ACTION_EMPLOYEE_IDS', payload);
  },
  setBulkActionGoalUuids({ commit }, payload) {
    commit('SET_BULK_ACTION_GOAL_UUIDS', payload);
  },
  async onClickCreateNewGoal(context) {
    context.state.isModalGoalType = true;
  },
  // eslint-disable-next-line consistent-return
  async getEssPermissions({ commit }, talentaURL) {
    try {
      if (!talentaURL) throw Error('Invalid URL. Please check with admin');
      if (localStorage.essPermission) throw Error('Using localStorage');

      const path = `${this._vm.$endPoint}/goals/check-permission-ess`;
      commit('SET_IS_LOADING_ESS', true);
      const { data, response } = await this._vm.$axios.get(path);

      if (data) {
        const permissionData = {
          ...data.contents,
          redirectUrl: data.contents.redirect_url,
          userHavePermission: data.contents.user_have_permission,
        };

        commit('SET_ESS_PERMISSIONS', permissionData);
        return permissionData || {};
      }

      throw response.data.message || 'Failed to fetch ESS permissions';
    } catch (err) {
      console.error(err.message);
    } finally {
      commit('SET_IS_LOADING_ESS', false);
    }
  },
  async cancelRequest(context, { id, requestStatus }) {
    const url = `${this._vm.$newEndPoint}/goals/cancel-request/${id}?request_status=${requestStatus}`;

    try {
      const { data, response } = await this._vm.$axios.post(url);

      if (data?.status_code === 200) {
        return 'Request sucessfully cancelled';
      }

      throw response?.data?.message || new Error('Failed to cancel request');
    } catch (err) {
      throw Error(err);
    }
  },
  async checkHasGoals() {
    const url = `${this._vm.$endPoint}/goals/company-has-goals`;

    try {
      const { data, status, statusMessage, response } = await this._vm.$axios.get(url);

      if (status === 200) return data?.contents?.is_has_goals; // eslint-disable-line camelcase

      throw response?.data?.message || statusMessage;
    } catch (err) {
      throw Error(err);
    }
  },
  async checkIsRequestedGoal({ commit }) {
    const path = `${this._vm.$newEndPoint}/goals/is-goal-requested`;

    try {
      const res = await this._vm.$axios.get(path);

      if (res?.data) {
        const isRequestedGoal = res.data.contents.is_goal_requested;

        commit('SET_IS_REQUESTED_GOAL', isRequestedGoal);
      } else throw res.response?.data.message || new Error('Failed checking is-goal-requested');
    } catch (err) {
      throw Error(err);
    }
  },
  async deleteGoal(context, uuid) {
    const path = `${this._vm.$newEndPoint}/goals/${uuid}`;

    try {
      const { data, response } = await this._vm.$axios.delete(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data.contents;
      }

      throw response.data.message;
    } catch (err) {
      throw Error(err);
    }
  },
  async getGoalType() {
    try {
      const path = `${this._vm.$newEndPoint}/goals/list-goal-type`;
      const { data, status, statusMessage, response } = await this._vm.$axios.get(path);

      if (status === 200 && data.status_code === 200) return data.contents;

      throw response?.data?.message || data?.message || statusMessage;
    } catch (err) {
      throw Error(err);
    }
  },
  async getParentGoals(context, params) {
    try {
      const queries = buildParams(params);
      const url = `${this._vm.$endPoint}/goals/parent-goal-pagination?`;
      const { data, response } = await this._vm.$axios.get(url + queries);

      if (data?.status_code === 200 && data.contents) return data.contents;

      throw response?.data?.message || data?.message || 'Failed to fetch parent goal';
    } catch (err) {
      throw Error(err);
    }
  },
  async setParentGoal(context, payload) {
    try {
      const url = `${this._vm.$endPoint}/goals/set-parent-goal`;
      const { data, response } = await this._vm.$axios.post(url, payload);

      if (data?.status_code === 200) return true;

      throw response?.data?.message || data?.message || 'Failed to align goal';
    } catch (err) {
      throw Error(err);
    }
  },
  async getParentDetail(context, uuid) {
    try {
      const url = `${this._vm.$newEndPoint}/goals/get-parent-goal/${uuid}`;
      const { data, response } = await this._vm.$axios.get(url);

      if (data?.status_code === 200 && data.contents) return data.contents;

      throw response?.data?.message || data?.message || 'Failed to fetch parent detail';
    } catch (err) {
      throw Error(err);
    }
  },
  async deleteGoalAttachment(context, uuid) {
    const path = `${this._vm.$endPoint}/goals/attachment/${uuid}`;

    try {
      const { data, response } = await this._vm.$axios.delete(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data.contents;
      }

      throw response?.data?.message || 'Failed delete attachment';
    } catch (err) {
      throw Error(err);
    }
  },
  async reuploadGoalAttachment(context, payload) {
    const path = `${this._vm.$endPoint}/goals/attachment/update`;

    try {
      const { data, response } = await this._vm.$axios.post(path, payload);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data.contents;
      }
      throw response?.data?.message || data?.message || 'Failed delete attachment';
    } catch (err) {
      throw Error(err);
    }
  },
  async checkEligibleCloseGoals(context, payload) {
    const url = `${this._vm.$endPoint}/goals/check-eligible-goal`;

    try {
      const { data, response } = await this._vm.$axios.post(url, { uuids: payload });

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data.contents;
      }

      throw response.data.message;
    } catch (err) {
      throw Error(err);
    }
  },
  async getGoalSettings({ commit }, payload) {
    const url = `${this._vm.$newEndPoint}/goal-settings/flags`;
    try {
      const { data, response } = await this._vm.$axios.get(url, { params: payload });
      if (data?.status_code !== 200) {
        throw response?.data?.message || data?.message || 'Failed to fetch goal settings flag';
      }
      const contents = data?.contents || {};
      commit('setGoalSettings', contents);
      return contents;
    } catch (err) {
      throw Error(err);
    }
  },
};

export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  mutations,
  getters,
  actions,
};
